
export const registerTypeList = [
  {key: '사내수급업체문서담당자', label: '사내 수급업체 안전 관련 문서 작성 담당자', value: '사내담당자'},
  {key: '사외수급업체문서담당자', label: '사외 수급업체 안전 관련 문서 작성 담당자', value: '사외담당자'},
  {key: '수급업체일반직원', label: '수급업체 일반직원', value: '수급일반'},
  {key: '일용직', label: '일용직', value: '일용직'},
]

export function getRegisterTypeInfo(key) {
  const type = registerTypeList.find(item => item.key === key);
  return type ? { value: type.value, label: type.label } : null;
}
